import { render, staticRenderFns } from "./TaskViewUsersDispatcher.vue?vue&type=template&id=6d65cc79&scoped=true&lang=pug&"
import script from "./TaskViewUsersDispatcher.vue?vue&type=script&lang=js&"
export * from "./TaskViewUsersDispatcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d65cc79",
  null
  
)

export default component.exports